//====================================================
//  Function: Category Create
//====================================================
var categoryGroup = $('.js-category-group')

function componentCategoryCreate() {
  if ($('.js-category-group').length) {
    categoryGroup = $('.js-category-group')

    addToCategoryResultCode()
    rebuildTopCategoryResult()

    $('.js-select-option').change(function () {
      var checkbox = $(this)
      // var checkboxValue = checkbox.val()
      // var checkboxCode = checkbox.closest('.js-select-item').data('code')
      $('div').removeClass('is-clicked')
      $('.code-box__item').removeClass('is-clicked')
      // clearTimeout(myTimeoutCode);
      addToCategoryResultCode()
      rebuildTopCategoryResult()
    })

    $(document).on(
      'keyup',
      '.js-select-input, .js-select-input-main, .js-select-input-another, .js-category-input',
      function () {
        addToCategoryResultCode()
        rebuildTopCategoryResult()
      },
    )

    $(document).on(
      'change',
      '.js-block-item-css .js-select-input',
      function () {
        addToCategoryResultCode()
        rebuildTopCategoryResult()
      },
    )

    $('.js-limit-input').each(function () {
      var inst = $(this)
      limitChars(inst)
    })

    $('.js-limit-input').keyup(function () {
      var inst = $(this)
      limitChars(inst)
    })
  }
}

function addToCategoryResultCode() {
  var arrayResultCategory = []
  var arrayResultCategoryCSS = []
  var arrayResultCategoryItems = []
  var arrayResultTextItems = []
  var arrayResultSubTextItems = []
  var arrayResultLinkItems = []
  var arrayResultSideCategory = []
  var mainItem = false
  var anotherItemText = true
  var anotherItemSubtext = true
  var anotherItemLink = true

  var index = $('.js-select-item')
  index.find('.js-block-item').each(function () {
    var item = $(this)
    var blockItemCSS = item.hasClass('js-block-item-css')
    if (item.data('comment') !== undefined) {
      if (item.data('comment').length) {
        if (blockItemCSS) {
          arrayResultCategoryCSS.push(
            "<div class='code__comment'>/* " +
              item.data('comment') +
              '*/</div>',
          )
        } else {
          arrayResultCategory.push(
            "<div class='code__comment'>// " + item.data('comment') + '</div>',
          )
        }
      }
    }

    item.find('.js-json-input').each(function () {
      input = $(this)
      var dataJson = input.attr('data-json')
      var dataVar = input.attr('data-var')
      if (input.val().length > 0) {
        var inputValue = input.val()
        if (dataVar === 'turskyHIBAddonTextLang') {
          arrayResultTextItems.push(`${dataJson}:"${inputValue}"`)
        }

        if (dataVar === 'turskyHIBAddonLinkLang') {
          arrayResultSubTextItems.push(`${dataJson}:"${inputValue}"`)
        }

        if (dataVar === 'turskyHIBAddonBtnTextLang') {
          arrayResultLinkItems.push(`${dataJson}:"${inputValue}"`)
        }
      }
    })

    if (anotherItemText) {
      if (arrayResultTextItems.join().length > 0) {
        var templateBoxItem = `
					<div class="code-box__item">
					<strong>var <span class="js-result-type">turskyHIBAddonTextLang</span> = <span class="js-result-value txt-green">{${arrayResultTextItems.join()}};</span></strong></div>
				`
        arrayResultCategory.push(templateBoxItem)
        anotherItemText = false
      }
    }

    if (anotherItemSubtext) {
      if (arrayResultSubTextItems.join().length > 0) {
        var templateBoxItem = `
					<div class="code-box__item">
					<strong>var <span class="js-result-type">turskyHIBAddonLinkLang</span> = <span class="js-result-value txt-green">{${arrayResultSubTextItems.join()}};</span></strong></div>
				`
        arrayResultCategory.push(templateBoxItem)
        anotherItemSubtext = false
      }
    }

    if (anotherItemLink) {
      if (arrayResultLinkItems.join().length > 0) {
        var templateBoxItem = `
					<div class="code-box__item">
					<strong>var <span class="js-result-type">turskyHIBAddonBtnTextLang</span> = <span class="js-result-value txt-green">{${arrayResultLinkItems.join()}};</span></strong></div>
				`
        arrayResultCategory.push(templateBoxItem)
        anotherItemLink = false
      }
    }

    item.find('.js-select-input').each(function () {
      var input = $(this)
      var inputParent = input.closest('.js-stats')
      var inputValue = input.val()
      var inputCode = inputParent.data('code')
      var inputQuotes = inputParent.data('quotes')
      var inputPX = inputParent.data('px')
      var inputType = inputParent.data('type')

      if (blockItemCSS) {
        inputValue = '' + inputValue + ''
      } else {
        if (inputQuotes == true) {
          inputValue = '"' + inputValue + '"'
        }

        if (inputPX == true) {
          inputValue = inputValue + 'px'
        }

        if (inputType == 'number') {
          inputValue = parseInt(inputValue)
        } else {
          inputValue = '"' + inputValue + '"'
        }
      }

      // var templateBoxItem = `
      // 		<div class="code-box__item">
      // 		<strong>var <span class="js-result-type">${inputCode}</span> = <span class="js-result-value txt-green">${inputValue};</span></strong></div>
      // `
      if (input.hasClass('js-json-input')) {
      } else {
        if (blockItemCSS) {
          var templateBoxItem = `
						<div class="code-box__item">
						<strong>--<span class="js-result-type">${inputCode}</span>: <span class="js-result-value txt-green">${inputValue};</span></strong></div>
					`
          arrayResultCategoryCSS.push(templateBoxItem)
          inputParent
            .find('.js-label-value')
            .html('--' + inputCode + ' = <span> ' + inputValue + '</span>')
        } else {
          var templateBoxItem = `
						<div class="code-box__item">
						<strong>var <span class="js-result-type">${inputCode}</span> = <span class="js-result-value txt-green">${inputValue};</span></strong></div>
					`
          arrayResultCategory.push(templateBoxItem)
          arrayResultSideCategory.push(templateBoxItem)
          inputParent
            .find('.js-label-value')
            .html('var ' + inputCode + ' = <span> ' + inputValue + '</span>')
        }
      }
    })

    item.find('.js-stats-checkbox').each(function () {
      var element = $(this)
      var checkedCheckbox = element.find('.js-select-option')
      var checkboxValue = checkedCheckbox.val()
      var clickedClass = ''
      var checkboxCode = element.data('code')
      var checkboxQuotes = element.data('quotes')

      if (checkedCheckbox.is(':checked')) {
        checkboxValue = true
      } else {
        checkboxValue = false
      }

      if (checkboxQuotes == true) {
        checkboxValue = '"' + checkboxValue + '"'
      }

      if (element.hasClass('is-clicked')) {
        clickedClass = 'is-clicked'
      }

      if (element.attr('data-type') === 'option') {
        checkboxValue = `"${element.find('select').val()}"`
      }

      // if (checkboxValue === 'false' || checkboxValue === '"left"') {
      //   return false
      // }

      var templateBoxItem = `
			<div class="code-box__item ${clickedClass}">
			<strong>var <span class="js-result-type">${checkboxCode}</span> = <span class="js-result-value txt-green">${checkboxValue};</span></strong></div>
			`
      arrayResultCategory.push(templateBoxItem)
      arrayResultSideCategory.push(templateBoxItem)
      element
        .find('.js-label-value')
        .html('var ' + checkboxCode + ' = <span> ' + checkboxValue + '</span>')
    })

    if (item.hasClass('line-break')) {
      arrayResultCategory.push('<br>')
      // arrayResultSide.push('<br>')
    }
  })

  $('.js-code-result').empty()
  $('.js-code-result--side').empty()
  $('.js-code-result--subcategory').empty()
  $('.js-code-result--css').empty()
  $('.js-code-result').append(arrayResultCategory)
  $('.js-code-result--side').append(arrayResultSideCategory)
  $('.js-code-result--css').append(arrayResultCategoryCSS)
}

var turskyHIBTemplate
var turskyHIBIcon = ''
var turskyHIBAddon
var turskyHIBText = ''
var turskyHIBBtnText = ''
var turskyHIBCenter = ''
var turskyHIBClose = ''
var turskyHIBCloseTemplate = ''
var turskyHIBFullWidth = ''
var turskyHIBPosition = ''
var turskyHIBFixedMobile = ''

var turskyHIBAddonBody = $('body')

function rebuildTopCategoryResult() {
  buttonsBlock = $('.result-block')

  turskyHIBAddon = $('#tursky_hib_active').is(':checked')
  turskyHIBAddonIcon = $('#tursky_hib_icon_type').val()
  turskyHIBAddonText = $('#tursky_hib_text').val()
  turskyHIBAddonBtnText = $('#tursky_hib_btn_text').val()
  turskyHIBAddonLink = $('#tursky_hib_link_url').val()
  turskyHIBAddonExternal = $('#tursky_hib_link_url_external').is(':checked')

  turskyHIBAddonCenter = $('#tursky_hib_center').is(':checked')
  turskyHIBAddonClose = $('#tursky_hib_close').is(':checked')
  turskyHIBAddonFullWidth = $('#tursky_hib_full_width').is(':checked')

  turskyHIBAddonBig = $('#tursky_hib_big').is(':checked')
  turskyHIBAddonPosition = $('#tursky_hib_position').val()
  turskyHIBAddonFixedMobile = $('#tursky_hib_fixed').is(':checked')

  // CSS
  let root = document.documentElement

  root.style.setProperty('--header-info-bar-BG', $('#tursky_hib_bgs').val())

  root.style.setProperty(
    '--header-info-bar-BG-hover',
    $('#tursky_hib_bg-hover').val(),
  )

  root.style.setProperty(
    '--contact-form-title-color',
    $('#contact_form_title_color').val(),
  )

  root.style.setProperty(
    '--header-info-bar-text-color',
    $('#tursky_hib_text_color').val(),
  )

  root.style.setProperty(
    '--header-info-bar-icon-color',
    $('#header-info-bar_icon_color').val(),
  )

  root.style.setProperty(
    '--header-info-bar-btn-BG',
    $('#tursky_hib_btn_bgs').val(),
  )

  root.style.setProperty(
    '--header-info-bar-btn-BG-hover',
    $('#tursky_hib_btn_bg-hover').val(),
  )

  root.style.setProperty(
    '--header-info-bar-btn-text-color',
    $('#tursky_hib_btn_text_color').val(),
  )

  root.style.setProperty(
    '--header-info-bar-text-color',
    $('#tursky_hib_text_color').val(),
  )

  if (turskyHIBAddon) {
    turskyHIBAddonBody.addClass('header-info-bar-addon')
    removeButton()
    setHIBText()
    setHIBIcon()
    setHIBDesign()

    createHIB()
  } else {
    turskyHIBAddonBody.removeClass('header-info-bar-addon')
    $('body').removeClass('is-hib-top')
    $('body').removeClass('is-hib-bottom')
    removeButton()
  }
}

function setHIBBody() {
  if (turskyHIBAddonFixedMobile) {
    turskyHIBAddonBody.addClass('is-hib-mobile-fixed')
  } else {
    turskyHIBAddonBody.removeClass('is-hib-mobile-fixed')
  }

  if (turskyHIBAddonPosition == 'top') {
    turskyHIBAddonBody.addClass('is-hib-top')
  } else {
    turskyHIBAddonBody.addClass('is-hib-bottom')
  }

  if (turskyHIBAddonBig) {
    turskyHIBAddonBody.addClass('is-hib-big')
  } else {
    turskyHIBAddonBody.removeClass('is-hib-big')
  }
}

function createHIB() {
  turskyHIBTemplate = `
    <div class="js-header-info-bar header-info-bar ${turskyHIBClose} ${turskyHIBFullWidth} ${turskyHIBCenter} ${turskyHIBFixedMobile}">
      <div class="containers">
        <div class="header-info-bar__content">
          ${turskyHIBCloseTemplate}
          <div class="header-info-bar__left-panel">
            <span class="header-info-bar__text">
            	${turskyHIBIcon}
              ${turskyHIBText}
            </span>
          </div>
          ${turskyHIBBtnText}
        </div>
      </div>
    </div>
	`

  addHIBAddon()
  setHIBBody()

  if (turskyHIBAddonLink.length > 0) {
    if (turskyHIBAddonFullWidth) {
      var headerInfoContainer = '.js-header-info-bar'
    } else {
      var headerInfoContainer = '.js-header-info-bar .containers'
    }
    if (turskyHIBAddonExternal) {
      $(headerInfoContainer).wrapInner(
        `<a class="header-info-bar__link" href="/${turskyHIBAddonLink}" target="_blank">`,
      )
    } else {
      $(headerInfoContainer).wrapInner(
        `<a class="header-info-bar__link" href="/${turskyHIBAddonLink}">`,
      )
    }
  }
}

function addHIBAddon() {
  if (turskyHIBAddonPosition == 'top') {
    $(turskyHIBTemplate).insertBefore('.header-block')
  } else {
    $(turskyHIBTemplate).insertAfter('.header-block')
  }
}

// Set design for button in detail
function setHIBDesign() {
  if (turskyHIBAddonCenter) {
    turskyHIBCenter = 'is-centered'
  } else {
    turskyHIBCenter = ''
  }

  if (turskyHIBAddonClose) {
    turskyHIBCloseTemplate = '<div class="header-info-bar__close"></div>'
    turskyHIBClose = 'has-cross'
  } else {
    turskyHIBCloseTemplate = ''
    turskyHIBClose = ''
  }

  if (turskyHIBAddonFullWidth) {
    turskyHIBFullWidth = 'is-full-width'
  } else {
    turskyHIBFullWidth = ''
  }
}

// Set text for button in detail
function setHIBText() {
  if (turskyHIBAddonText) {
    turskyHIBText = turskyHIBAddonText
  } else {
    turskyHIBText = ''
  }

  if (turskyHIBAddonBtnText.length > 0) {
    turskyHIBBtnText = `
      <div class="header-info-bar__right-panel">
        <button class="header-info-bar__btn">${turskyHIBAddonBtnText}</button>
      </div>
    `
  } else {
    turskyHIBBtnText = ''
  }
}

// Set icon for header info bar
function setHIBIcon() {
  if (turskyHIBAddonIcon.length > 0) {
    turskyHIBIcon = `<div class="header-info-bar__icon hib-ico ${turskyHIBAddonIcon}"></div>`
  } else {
    turskyHIBIcon = ''
  }
}

function removeButton() {
  $('.js-header-info-bar').remove()
}

// Change color picker
$('.picker-color__item').each(function () {
  var input = $(this)
  var inputColorBlock = input.find('.picker-color__input')
  var inputColor = inputColorBlock.find('input')
  var inputNumber = input.find('.js-select-input')
  var inputName = inputColor.attr('name')
  var inputValue
  inputColor.on('input', function (e) {
    inputValue = e.target.value
    inputNumber.val('#' + e.target.value.substring(1))
  })
  inputColor.change(function (e) {
    inputValue = e.target.value
    inputNumber.val('#' + e.target.value.substring(1))
    inputNumber.trigger('change')
  })

  inputNumber.keyup(function (e) {
    inputValue = e.target.value
    inputColor.val('#' + inputValue)
    // inputColor.trigger('change')
  })
})

function limitChars(el) {
  var input = el
  var limit = 100
  var infodiv = input.closest('.col-12').find('.js-input-counter')
  var text = input.val()
  var textlength = text.length
  if (textlength > limit) {
    infodiv.html('Neodporúčam použíť viac ako ' + limit + ' znakov!')
    input.val(text.substr(0, limit))
    return false
  } else {
    infodiv.html('Ostáva ' + (limit - textlength) + ' znakov.')
    return true
  }
}
